var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavDownloadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13H12.5C12.9142 13 13.25 13.3358 13.25 13.75C13.25 14.1297 12.9678 14.4435 12.6018 14.4932L12.5 14.5H3.5C3.08579 14.5 2.75 14.1642 2.75 13.75C2.75 13.3703 3.03215 13.0565 3.39823 13.0068L3.5 13H12.5H3.5ZM7.89823 1.00685L8 1C8.3797 1 8.69349 1.28215 8.74315 1.64823L8.75 1.75V9.438L11.0052 7.18414C11.2715 6.91787 11.6881 6.89366 11.9817 7.11152L12.0659 7.18414C12.3321 7.4504 12.3563 7.86707 12.1385 8.16068L12.0659 8.2448L8.53033 11.7803C8.26406 12.0466 7.8474 12.0708 7.55379 11.8529L7.46967 11.7803L3.93414 8.2448C3.64124 7.9519 3.64124 7.47703 3.93414 7.18414C4.2004 6.91787 4.61707 6.89366 4.91068 7.11152L4.9948 7.18414L7.25 9.44V1.75C7.25 1.3703 7.53215 1.05651 7.89823 1.00685L8 1L7.89823 1.00685Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDownloadArrow);
export default __webpack_public_path__ + "static/media/NavDownloadArrow.3ae388b7d09fd90caf75525531b01109.svg";
export { ForwardRef as ReactComponent };